import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { FileUpload, TabsConfiguration, Response, ChoosenValue } from '../models';
import { DiscountingConfig, FileConfig, SectionByTool } from '../models/tool.model';

export interface ChunkInfo {
  offset: number;
  length: number;
  chunk: ArrayBuffer;
}
@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(
    private http: HttpClient,
  ) {
  }

  generateChunk(file: File, data: ArrayBuffer): ChunkInfo[] {
    let offset = 0;
    const defaultChunkLength = 1048576 * 20; // 50 mb
    // the total file size in bytes...
    const total = file.size;
    // 1MB Chunks as represented in bytes (if the file is less than a MB, seperate it into two chunks of 80% and 20% the size)...
    // how many
    const chunks = [];
    do {
      const calcSize = total - offset < defaultChunkLength ? total - offset : defaultChunkLength;
      const calcChunk = this.convertFileToBlobChunks(data, offset, calcSize);
      chunks.push({
        offset,
        length: calcSize,
        chunk: calcChunk,
      });
      offset += calcSize;
    } while (offset < total);
    return chunks;
  }
  generateGUID() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  convertFileToBlobChunks(result: ArrayBuffer, offset: number, length: number) {

    return result.slice(offset, offset + length);
  }

  async getFile(id: string, type: string, file: File, tab: string, section: string, can_public_access_this?:boolean) {
    //console.log("get-file");

    return new Promise<FileUpload[]>(
      (resolve, reject) => { 
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent) => {
          const idChunksFile = this.generateGUID();
          const chunkedMap = this.generateChunk(file, (e.target as FileReader).result as ArrayBuffer);
          // console.log(chunkedMap)
          const array = this.getChunk(id, type, file, tab, section, idChunksFile, chunkedMap, can_public_access_this);
          
          Promise.all(array).then((res: FileUpload[]) => {
            //console.log("then")
            resolve(res);
            reject(res);
          }).catch((r) => {
            // console.log(r)
            reject(r);
            throw r;
          });
        };
      reader.readAsArrayBuffer((file as unknown as Blob));
    });
    }

    getChunk(id: string, type: string, file: File, tab: string, section: string, idChunksFile: string, chunkedMap: ChunkInfo[], can_public_access_this?:boolean) {

        //console.log("Chunked_map")
        return chunkedMap.map(
      (singleChunk, index) => this.uploadInputFile(
            id, type, file,
            idChunksFile, index, chunkedMap.length, singleChunk.chunk.byteLength,
            singleChunk.chunk,
          tab, section, can_public_access_this).then(r => r).catch(r => {
              // console.log(r);
              throw r;
          })
      );
  }

  async uploadInputFile(
    id: string, type: string, file: File,
    idChunk: string, index: number, totNumberChunk: number, chunkLength: number,
    binary: string | ArrayBuffer,
    tab: string, section: string, can_public_access_this?: boolean
  ): Promise<FileUpload> {
      // console.log(binary    )
      let cpat = can_public_access_this ? true:false
    let options = `id=${id}&type=${type}&filename=${file.name}`;
    options += `&id_chunk=${idChunk}&chunk_length=${chunkLength}&number_chunk=${index}&tot_chunk=${totNumberChunk}`;
      options += `&tab=${tab}&section=${section}`;
      if (cpat) options += '&can_public_access_this='+cpat
    return await this.http.post<FileUpload>(`${environment.apiUrl}/UploadChunkInputFileTool?${options}`,
      binary
    ).toPromise().then(res => res).catch(err => {
      // console.log(err);
      throw err;
    });
  }

    async getFileNLLTemplateAssociation(id: string, type: string, file: File, tab: string, section: string, can_public_access_this?: boolean) {
        return new Promise<FileUpload[]>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent) => {
                // Get file length
                // Generate file id
                const idChunksFile = this.generateGUID();
                // Split file into chunk
                const chunkedMap = this.generateChunk(file, (e.target as FileReader).result as ArrayBuffer);
                // Map chunck and call this.uploadInputFile
                const array = this.getChunkNLLTemplateAssociation(id, type, file, tab, section, idChunksFile, chunkedMap, can_public_access_this);
                Promise.all(array).then((res: FileUpload[]) => {
                    resolve(res);
                    reject(res);
                }).catch(() => {
                });
            };
            reader.readAsArrayBuffer((file as unknown as Blob));
        });
    }

    getChunkNLLTemplateAssociation(id: string, type: string, file: File, tab: string, section: string, idChunksFile: string, chunkedMap: ChunkInfo[], can_public_access_this?: boolean) {
        return chunkedMap.map(
            (singleChunk, index) => this.uploadInputFileNLLTemplateAssociation(
                id, type, file,
                idChunksFile, index, chunkedMap.length, singleChunk.chunk.byteLength,
                singleChunk.chunk,
                tab, section, can_public_access_this)
        );
    }

    async uploadInputFileNLLTemplateAssociation(
        id: string, type: string, file: File,
        idChunk: string, index: number, totNumberChunk: number, chunkLength: number,
        binary: string | ArrayBuffer,
        tab: string, section: string, can_public_access_this?: boolean
    ): Promise<FileUpload> {
        let cpat = can_public_access_this ? true : false
        let options = `id=${id}&type=${type}&filename=${file.name}`;
        options += `&id_chunk=${idChunk}&chunk_length=${chunkLength}&number_chunk=${index}&tot_chunk=${totNumberChunk}`;
        options += `&tab=${tab}&section=${section}`;
        if (cpat) options += '&can_public_access_this=' + cpat
        return await this.http.post<FileUpload>(`${environment.apiUrl}/NLL_UpdatePortfolioAssociation?${options}`,
            binary
        ).toPromise().then(res => res).catch(err => err);
    }
    

  async getSectionsByTool(idExecution: string, currency?: string): Promise<TabsConfiguration> {
    let params = new HttpParams();
    params = params.append('id', idExecution);
    if (currency) {
      params = params.append('currency_tab', currency);
    }
    return await this.http.get<TabsConfiguration>(`${environment.apiUrl}/GetFilesByExecution`,
      {
        params      }
    ).toPromise();
  }

  async sendConfiguration(idExecution : string, param : FileConfig){
    return this.http.post<any>(`${environment.apiUrl}/updateConfigurationForExecution`,
    {
      id_execution: idExecution,
      config : param
    }
  ).toPromise();

  }


  deleteSingleFile(idFile: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/DeleteSingleFile`,
      {
        id_file: idFile
      }
    ).toPromise();
  }

  changeSingleFileConfig(idFile: string, name: string, value: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/ChangeSingleFileConfig`,
      {
        id_file: idFile,
        name,
        value
      }
    ).toPromise();
  }


  updateSingleGeneralConfig(idExecution: string, name: string, value: string, customConfig?: any): Promise<Response> {
      return this.http.post<Response>(`${environment.apiUrl}/UpdateSingleGeneralConfig`,
          {
              id_execution: idExecution,
              name,
              value,
              customConfig
          }
      ).toPromise();
    }

  updateSingleTabConfig(idExecution: string, name: string, value: string, tabId: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/UpdateSingleTabConfig`,
      {
        id_execution: idExecution,
        name,
        value,
        tab_id: tabId
      }
    ).toPromise();
  }

  getAvailableCurrencies(idExecution: string): Promise<{ currency_list: ChoosenValue[] }> {
    let params = new HttpParams();
    params = params.append('id-execution', idExecution);
    return this.http.get<{ currency_list: ChoosenValue[] }>(`${environment.apiUrl}/GetAvailableCurrencies`,
      {
        params
      }
    ).toPromise();
  }

  createNewFund(idExecution: string, parameters: DiscountingConfig[]): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/LCFCreateNewFund`,
      {
        id_execution: idExecution,
        parameters
      }
    ).toPromise();
  }

  createNewStress(idExecution: string, idFund: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/LCFCreateNewStress`,
      {
        id_execution: idExecution,
        id_fund: idFund
      }
    ).toPromise();
  }

  removeStressType(idExecution: string, idEntity: string, type: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/RemoveEntityFromFilesSection`,
      {
        id_execution: idExecution,
        id_entity: idEntity,
        type
      }
    ).toPromise();
  }

  createNewSet(idExecution: string, parameters: DiscountingConfig[]): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/ESGCreateNewSet`,
      {
        id_execution: idExecution,
        parameters
      }
    ).toPromise();
  }

  updateGranularityFiles(idExecution: string, name: string, value: string): Promise<SectionByTool[]> {
    return this.http.post<SectionByTool[]>(`${environment.apiUrl}/UpdateGranularity_IFRS17L`,
      {
        id_execution: idExecution,
        name,
        value
      }
    ).toPromise();
  }
}
